import React from 'react'
import { Field, FastField, ErrorMessage } from 'formik'
import { Box } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

const PolicyGeneralInfo = ({ formikBag, type }) => {
  const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formikBag

  return (
    <Box p={{ xs: 0.75, lg: 3.75 }} display="flex" flexDirection="column" rowGap={4}>
      <FastField
        as={AdxInput}
        label="Policy name"
        charLimit={50}
        name="name"
        // value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Eg. Annual Leave"
        errorMessage={<ErrorMessage name="name" component={AdxErrorMessage} />}
        isErrorShown={errors.name && touched.name}
        sx={{ width: 1 }}
      />
      <Box>
        <FastField
          as={AdxInput}
          label="Description"
          charLimit={120}
          name="description"
          // value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Description is for admin reference only."
          errorMessage={<ErrorMessage name="description" component={AdxErrorMessage} />}
          isErrorShown={errors.description && touched.description}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 2.5 }}>
        <AdxFormControlLabel
          type="no-fill"
          label="Requires documentation"
          description="Enable if documentation is required to apply (e.g Doctor's Medical Certificate)"
          control={
            <Field
              as={AdxCheckbox}
              name="attachment_required"
              checked={values.attachment_required}
              onChange={(e) => setFieldValue('attachment_required', e.target.checked)}
            />
          }
        />
        <AdxFormControlLabel
          type="no-fill"
          label="Requires reasoning / description"
          description="Enable if reasoning is required to apply"
          control={
            <Field
              as={AdxCheckbox}
              name="reason_required"
              checked={values.reason_required}
              onChange={(e) => setFieldValue('reason_required', e.target.checked)}
            />
          }
        />
        <AdxFormControlLabel
          type="no-fill"
          label="Allow half day option"
          description="Enable if half-day is allowed"
          control={
            <Field
              as={AdxCheckbox}
              name="half_day_option"
              checked={values.half_day_option}
              onChange={(e) => setFieldValue('half_day_option', e.target.checked)}
            />
          }
        />
        <AdxFormControlLabel
          type="no-fill"
          label="Include non-working days"
          description="Enable if policy required leaves to include non-working days"
          control={
            <Field
              as={AdxCheckbox}
              name="include_non_working_days"
              checked={values.include_non_working_days}
              onChange={(e) => setFieldValue('include_non_working_days', e.target.checked)}
            />
          }
        />
        {values.cycle_period === 'monthly' || type === 'WITHOUT' ? null : (
          <AdxFormControlLabel
            type="no-fill"
            label="Allow replacement credit deduction"
            description="Enable if employees can use replacement leave credit"
            control={
              <Field
                as={AdxCheckbox}
                name="credit_deduction"
                checked={values.credit_deduction}
                onChange={(e) => setFieldValue('credit_deduction', e.target.checked)}
              />
            }
          />
        )}
      </Box>
    </Box>
  )
}

export default PolicyGeneralInfo
